<template>
  <div class="flex flex-col text-gray-dark">
    <span class="font-bold text-xl">Read-Only</span>

    <div v-if="isTemplateVariant" class="mt-2">
      Blocks can only be managed in the primary market.
    </div>

    <template v-else>
      <div class="mt-2">
        If you wish to make changes to "{{ item.name }}" for the {{ marketName }} market, then automatic translations will be stopped for this market.
      </div>
      <busy-button :id="BUSY_BUTTONS.EDIT_MARKET"
                   :is-loading="isEditMarketBusy"
                   variant="bordered"
                   class="mt-10"
                   @click="$emit('edit-market')"
      >
        Edit this market
      </busy-button>
    </template>
  </div>
</template>

<script>
import BusyButton from '@/components/common/BusyButton'
import botModule from '@/store/modules/bot.module'
import busyButtonsModule from '@/store/modules/busy-buttons.module'
import { BUSY_BUTTONS } from '@/utils/busy-buttons.constants'

export default {
  name: 'ConversationEditorReadOnly',

  components: {
    BusyButton
  },
  props: {
    botId: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    isTemplateVariant: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      BUSY_BUTTONS
    }
  },

  computed: {
    botVariantList: botModule.getBotVariantList,

    marketName() {
      return this.botVariantList.find(botVariant => botVariant.primaryBotId === this.botId)?.name
    },

    isEditMarketBusy() {
      return busyButtonsModule.isButtonBusy(BUSY_BUTTONS.EDIT_MARKET)
    }
  }
}
</script>